import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getSubsectionNumber, getDataGroup } from 'actions';

import Icon from 'components/common/Icon';
import isEmpty from 'lodash/isEmpty';

import EventDataGroupItem from 'components/calendar/EventDataGroupItem';

class EventDataGroupHeader extends Component {
  constructor(props) {
    super(props);

    // Default expanded is true if I have children selected (otherwise expanded = false)
    this.state = { expanded: false };
    this.toggleExpanded = this.toggleExpanded.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.search > '' && nextProps.items && nextProps.items.length > 0) {
      this.setState({ expanded: true });
    }
    if (isEmpty(nextProps.search) && !isEmpty(this.props.search)) {
      this.setState({ expanded: false });
    }
  }

  toggleExpanded(e) {
    e.stopPropagation();
    const { items, section, subsection, mainSubsection, search, config } = this.props;
    if (!this.state.expanded && (!items || items.length === 0) && isEmpty(search)) {
      this.props.getDataGroup(section, subsection, config, null, 'all', null);
    }
    this.setState({ expanded: !this.state.expanded });
  }

  render() {
    const { items, section, subsection, mainSubsection, search, title, config } = this.props;
    const itemClass = 'is-group-header';

    const expandIcon =
      this.state.expanded ?
        (<span className="clickable"><Icon icon="arrow" className="rotate-90" /></span>) :
        (<span className="clickable"><Icon icon="arrow" /></span>);

    const renderItem = (item, key) => {
      let isSelectable = true;

      switch (section) {
      case 'equipment':
        isSelectable = false;
        if (item.subsection === 'equipment') {
          isSelectable = true;
        }
        break;
      case 'groups':
        isSelectable = true;
        if (item.subsection === 'school_user') {
          isSelectable = false;
        }
        break;
      case 'locations':
      default:
        isSelectable = true;
      }

      // const useSubsection = mainSubsection ? mainSubsection : subsection;
      const useSubsection = subsection;

      return (
        <EventDataGroupItem
          item={item}
          key={key}
          section={section}
          subsection={useSubsection}
          config={config}
          parentId={null}
          depth={0}
          isSelectable={isSelectable}
          search={search}
        />
      );
    };

    return (
      <li
        className={itemClass}
        onClick={this.toggleExpanded}
        style={{
          padding: 0,
          paddingTop: 15,
        }}
      >
        <span className="clickable row-text" style={{ fontSize: 15, fontWeight: 'bold', paddingLeft: 15 }}>
          {title}
          {items && search && search > '' && (
            <span>&nbsp;({items.length})</span>
          )}
        </span>
        {expandIcon}

        {this.state.expanded && items && items.length > 0 && (
          <ul>
            {items.map(renderItem)}
          </ul>
        )}
      </li>
    );
  }
}

function mapStateToProps(/* state, ownProps */) {
  return {};
}

export default connect(mapStateToProps, {
  getSubsectionNumber,
  getDataGroup,
})(EventDataGroupHeader);



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventDataGroupHeader.js